const init = () => {

    let menuIsActive = false;

    const hamburgerHandler = () => {
        const hamburger: string = `js-hamburger`;
        const menu: string = `js-header__menu`;
        

        $(`.${hamburger}`).on('click touch', e =>{

            const menuWidth: number = $(`.${menu}`).width();
            menuIsActive = !menuIsActive;
            $(`.${hamburger}`).toggleClass('is-active');
            $(`.${menu}`).toggleClass('header__menu--active');

            if(menuIsActive){
                $(`#main`).css(`transform`,`translate(${menuWidth}px)`);
                $(`#main`).css(`transform`,`translate(${menuWidth}px)`);
                $(`body`).css(`width`,`100%`);
                $(`body`).css(`overflow`,`hidden`);
            }else{
                $(`#main`).css(`transform`,`translate(0px)`);
                $(`#main`).css(`transform`,`translate(0px)`);
                setTimeout(()=>{$(`body`).removeAttr(`style`);}, 300);
                
            }
            
        })
    }

    const megamenuhandler = () => {
        const megamenu: string = `js-megamenu`;
        const megamenuBtn = $(`.${megamenu}`).find(`.header__menu-item`);
        megamenuBtn.on('click touch', e =>{
            $(`.${megamenu}`).toggleClass(`header__megamenu--active`);
        })
    }

    const subheaderHandler = () => {
        const activeMenu: string = `js-header-menu-active`;
        const sumenuTitle: string = `js-header__submenu-title`;
        const submenuBtn: string = `js-header__submenu-btn`;
        const submenuContainer: string = `js-header__submenu-container`;
        $(`.${sumenuTitle}`).text($(`.${activeMenu}`).text())

        $(`.${submenuBtn}`).on('click touch', ()=> {
            $(`.${submenuContainer}`).toggleClass('header__submenu-container--active')
        })

    }

    const languageHandler = () => {
        const langmenu: string = `.js-language`;
        $(document).on('click touch', langmenu, e => {     
            const $this = $(e.currentTarget); 
            $this.toggleClass(`header__language--active`);
        })
    }

    hamburgerHandler();
    megamenuhandler();
    subheaderHandler();
    languageHandler();
}

export const hamburger = {
	init: init
};